import createVueApp from '@phoenix/createVueApp';

import { PhxsgCollectionsBlock } from './index';

document.querySelectorAll('[data-component="phxsg-collections-block"]').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgCollectionsBlock', PhxsgCollectionsBlock);
  app.mount(el);
});
